import loader from '@monaco-editor/loader';
import * as monaco from 'monaco-editor';
import EditorWorker from 'monaco-editor/esm/vs/editor/editor.worker?worker';
import JsonWorker from 'monaco-editor/esm/vs/language/json/json.worker?worker';
import CssWorker from 'monaco-editor/esm/vs/language/css/css.worker?worker';
import HtmlWorker from 'monaco-editor/esm/vs/language/html/html.worker?worker';
import TsWorker from 'monaco-editor/esm/vs/language/typescript/ts.worker?worker';

loader.config({ monaco });

const getWorker = (_moduleId: string, label: string) => {
	switch (label) {
		case 'json':
			return new JsonWorker();
		case 'css':
		case 'scss':
		case 'less':
			return new CssWorker();
		case 'html':
		case 'handlebars':
		case 'razor':
			return new HtmlWorker();
		case 'typescript':
		case 'javascript':
			return new TsWorker();
		default:
			return new EditorWorker();
	}
};

if (typeof self !== 'undefined') {
	(self as typeof globalThis & { MonacoEnvironment?: { getWorker: typeof getWorker } }).MonacoEnvironment = {
		getWorker,
	};
}

export default loader;
